module.exports = __webpack_public_path__ + "img/BURYAT.e8f54dbc.png";